import type { Type } from '@badrap/valita'

export type RestorationMigration = { action: (data: any) => any }

export function createRestoration<TFull>(options: { key: string; schema: Type<Partial<TFull>>; migrations?: RestorationMigration[] }) {
  const migrations = options.migrations ?? []
  const currentVersion = migrations.length

  return {
    get(): Partial<TFull> {
      if (!IS_BROWSER) return {}
      try {
        const raw = localStorage.getItem(options.key)
        if (!raw) return {}
        const parsed: unknown = JSON.parse(raw)
        if (!parsed || typeof parsed !== 'object' || typeof (parsed as { version?: unknown }).version !== 'number') return {}
        const { version, data } = parsed as { version: number; data: unknown }
        let migrated = data
        for (let i = version; i < currentVersion; i++) {
          migrated = migrations[i].action(migrated)
        }
        const result = options.schema.try(migrated, { mode: 'strip' })
        return result.ok ? result.value : {}
      } catch {
        return {}
      }
    },
    set(value: TFull): void {
      if (!IS_BROWSER) return
      try {
        localStorage.setItem(options.key, JSON.stringify({ version: currentVersion, data: value }))
      } catch {}
    },
    clear(): void {
      if (!IS_BROWSER) return
      try {
        localStorage.removeItem(options.key)
      } catch {}
    },
  }
}
